const LOGIN_PATHNAME = '/mmf-web/login';

export function redirectFromLogin(data) {
    const jwt = data.data ? data.data.jwt : data;
    if (jwt) {
        if (loginFromRN(jwt)) {
            return;
        }
        //更新localStorage中的jwt
        localStorage['em_sso_token'] = jwt;
        localStorage.removeItem('hideNoAuthMessage')
    }
    let return_url_fix = localStorage['return_url_fix'];
    if (return_url_fix) {
        localStorage.removeItem('return_url_fix');
        window.location.href = return_url_fix;
    } else {
        let returnUrl = data.returnUrl
        if (!returnUrl) {
            returnUrl = localStorage['return_url'];
        }
        let targetUrl = process.env.VUE_APP_URL;
        if (returnUrl) {
            let url = new URL(returnUrl);
            if (url.pathname !== LOGIN_PATHNAME) {
                targetUrl = returnUrl;
            }
        }
        window.location.href = targetUrl;
    }
}

export function loginFromRN(token) {
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
        const payload = JSON.stringify({token: token});
        localStorage.removeItem('em_sso_token');
        window.ReactNativeWebView.postMessage(payload);
        return true;
    } else {
        return false;
    }
}
